import React from 'react'
import { AllowedTextElements, TextTypes } from '../../../types/TextTypes'

export interface TextProps extends React.HTMLAttributes<HTMLElement> {
    type?: TextTypes
    tag?: AllowedTextElements
    children: React.ReactNode
}

const defaultTag = {
    [TextTypes.HEADING_1]: 'h1',
    [TextTypes.HEADING_2]: 'h2',
    [TextTypes.HEADING_3]: 'h3',
    [TextTypes.HEADING_4]: 'h4',
    [TextTypes.HEADING_5]: 'h5',
    [TextTypes.HEADING_6]: 'h6',
    [TextTypes.PARAGRAPH]: 'p',
    [TextTypes.LINK]: 'p',
    [TextTypes.SMALL_TEXT]: 'p',
    [TextTypes.BUTTON_DEFAULT]: 'span',
    [TextTypes.BUTTON_SMALL]: 'span',
}

const classes = {
    [TextTypes.HEADING_1]: 'text-xxxl font-medium',
    [TextTypes.HEADING_2]: 'text-xxl font-medium',
    [TextTypes.HEADING_3]: 'text-xl font-medium',
    [TextTypes.HEADING_4]: 'text-lg font-medium',
    [TextTypes.HEADING_5]: 'text-base font-medium',
    [TextTypes.HEADING_6]: 'text-sm font-medium',
    [TextTypes.PARAGRAPH]: 'text-base',
    [TextTypes.LINK]: 'text-base text-text-interactive cursor-pointer',
    [TextTypes.SMALL_TEXT]: 'text-sm text-text-tertiary',
    [TextTypes.BUTTON_DEFAULT]: 'text-base',
    [TextTypes.BUTTON_SMALL]: 'text-sm',
}

export const Text = ({ type = TextTypes.PARAGRAPH, tag, children, ...props }: TextProps): JSX.Element => {
    let elementTag: AllowedTextElements = 'p'

    if (!tag && defaultTag[type]) elementTag = defaultTag[type]
    if (tag) elementTag = tag

    return React.createElement(
        elementTag,
        { ...props, className: [classes[type], props.className].join(' ') },
        children,
    )
}
